const month = {
  0: {
    abbr: 'Jan',
    fullName: 'January',
  },
  1: {
    abbr: 'Feb',
    fullName: 'February',
  },
  2: {
    abbr: 'Mar',
    fullName: 'March',
  },
  3: {
    abbr: 'Apr',
    fullName: 'April',
  },
  4: {
    abbr: 'May',
    fullName: 'May',
  },
  5: {
    abbr: 'Jun',
    fullName: 'June',
  },
  6: {
    abbr: 'Jul',
    fullName: 'July',
  },
  7: {
    abbr: 'Aug',
    fullName: 'August',
  },
  8: {
    abbr: 'Sep',
    fullName: 'September',
  },
  9: {
    abbr: 'Oct',
    fullName: 'October',
  },
  10: {
    abbr: 'Nov',
    fullName: 'November',
  },
  11: {
    abbr: 'Dec',
    fullName: 'December',
  },
};

export function getMonthName(i) {
  return month[`${i % 12}`].fullName;
}

export function getMonthAbbr(i) {
  return month[`${i % 12}`].abbr;
}



// WEBPACK FOOTER //
// ./domain/Month/index.jsx